import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useDarkMode } from './DarkModeContext';
import Footer from './Footer';

function AmbassadorPrograms() {
    const { darkMode } = useDarkMode();

    return (
        <>
            <Helmet>
                <title>Ambassador Programs - Merra.ai</title>
                <meta name="description" content="Create UGC content for Merra and get paid per views. Apply by emailing hello@merra.ai to join our ambassador program." />
                <meta name="keywords" content="Merra ambassador, UGC for Merra, create content for Merra, paid per views, Merra creator" />
                <link rel="canonical" href="https://www.merra.ai/ambassador-programs" />
                <meta property="og:title" content="Ambassador Programs - Merra.ai" />
                <meta property="og:description" content="Create UGC content for Merra and get paid per views. Apply by emailing hello@merra.ai." />
                <meta property="og:url" content="https://www.merra.ai/ambassador-programs" />
            </Helmet>
            <div style={{
                maxWidth: '800px',
                margin: '0 auto',
                padding: '20px',
                fontFamily: 'Arial, sans-serif',
                lineHeight: '1.6',
                color: darkMode ? '#e0e0e0' : '#333',
                backgroundColor: darkMode ? '#1a1a1a' : 'white',
                minHeight: '100vh'
            }}>
                <div style={{ marginBottom: '30px' }}>
                    <Link to="/" style={{ color: darkMode ? '#4A9EFF' : '#1976d2', textDecoration: 'none' }}>
                        ← Back to Home
                    </Link>
                </div>

                <h1 style={{
                    color: darkMode ? '#ffffff' : '#2c3e50',
                    borderBottom: `2px solid ${darkMode ? '#AB5898' : '#AB5898'}`,
                    paddingBottom: '10px'
                }}>
                    Ambassador Programs
                </h1>

                <div style={{ marginTop: '30px', marginBottom: '50px' }}>
                    <p style={{ fontSize: '18px', lineHeight: '1.8', marginBottom: '20px' }}>
                        Want to create UGC (user-generated content) for Merra and get paid for it? We’re looking for creators who can make authentic content showcasing Merra.
                    </p>
                    <p style={{ fontSize: '16px', lineHeight: '1.8', marginBottom: '20px' }}>
                        You’ll be paid per views on the content we use. To apply, send an email to{' '}
                        <a href="mailto:hello@merra.ai" style={{ color: darkMode ? '#4A9EFF' : '#1976d2', textDecoration: 'underline' }}>
                            hello@merra.ai
                        </a>
                        {' '}and tell us about yourself and the kind of content you’d like to make. We’ll get back to you with next steps.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AmbassadorPrograms;
